var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__clip0_913_32860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.093 9.995L21.283.68h-1.94L12.23 8.768 6.55.68H0L8.589 12.91 0 22.68h1.94l7.51-8.542 5.999 8.542H22L13.093 9.995zm-2.658 3.024l-.87-1.218L2.64 2.109h2.981l5.588 7.822.87 1.218 7.264 10.166h-2.98l-5.928-8.296z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__clip0_913_32860"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .68)",
    d: "M0 0h30v30H0z"
  })))));
}
export default __webpack_public_path__ + "assets/static/media/twitter.f31a258c.svg";
export { SvgTwitter as ReactComponent };